import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleMd};
`;

export const ConditionLabel = styled.div`
  ${typographyV2.bodySm};
  white-space: pre-line;
  color: var(--text-soft);
`;
